import { NavLink } from 'react-router-dom';
import {
  Blocks,
  Briefcase,
  Building2,
  Cog,
  Send,
  Settings as SettingsIcon,
  UserCircle,
} from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';

type RailItem = {
  to: string;
  label: string;
  icon: typeof Cog;
  requireAnyPermission?: string[];
};

const items: RailItem[] = [
  { to: '/settings/general', label: 'General', icon: Cog, requireAnyPermission: ['organization.edit'] },
  { to: '/settings/account', label: 'Account', icon: UserCircle },
  {
    to: '/settings/organization',
    label: 'Organization',
    icon: Building2,
    requireAnyPermission: ['organization.edit', 'workspace.manage_members', 'workspace.manage_roles'],
  },
  { to: '/settings/job-board', label: 'Job Board', icon: Briefcase },
  { to: '/settings/integrations', label: 'Integrations', icon: Blocks },
  // { to: '/settings/ats', label: 'ATS', icon: ClipboardList },
  // { to: '/settings/calendar', label: 'Calendar', icon: Calendar },
  // { to: '/settings/email', label: 'Email', icon: Mail },
  { to: '/settings/outreach-accounts', label: 'Outreach Accounts', icon: Send, requireAnyPermission: ['outreach.view', 'outreach.edit'] },
];

export function SettingsRail() {
  const { hasAnyPermission } = useAuth();
  const visible = items.filter((item) =>
    item.requireAnyPermission ? hasAnyPermission(...item.requireAnyPermission) : true,
  );

  return (
    <nav className="ats-fullscreen-rail" aria-label="Settings navigation">
      <div className="ats-fullscreen-rail-header">
        <SettingsIcon size={16} strokeWidth={1.75} />
        <span>Settings</span>
      </div>
      <div className="ats-fullscreen-rail-list">
        {visible.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              isActive ? 'ats-fullscreen-rail-item active' : 'ats-fullscreen-rail-item'
            }
          >
            <Icon size={15} strokeWidth={1.75} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
